import { useLayoutEffect, useState } from 'react';

/*
Popover ancré sous son champ : décide s'il doit s'ouvrir vers le haut.
Mesure par rapport à la FENÊTRE : si le panneau déborde sous le viewport
et qu'il y a davantage de place au-dessus de l'ancre, on bascule (`flip`).
`anchorRef` est l'élément de référence ; à défaut, l'offsetParent du panneau
(le premier ancêtre positionné, celui qui sert de repère à l'absolute).
Recalculé à l'ouverture, au resize et au scroll ; la dernière valeur est
gardée à la fermeture pour ne pas faire sauter le panneau pendant le fondu.
*/
export default function usePopoverFlip({ open, panelRef, anchorRef }) {
  const [flip, setFlip] = useState(false);

  useLayoutEffect(() => {
    if (!open) return undefined;
    const compute = () => {
      const panel = panelRef.current;
      const anchor = anchorRef?.current || panel?.offsetParent;
      if (!panel || !anchor) return;
      const rect = anchor.getBoundingClientRect();
      const below = window.innerHeight - rect.bottom;
      const above = rect.top;
      setFlip(panel.offsetHeight > below && above > below);
    };
    compute();
    // Un panneau monté via Transition (headlessui) n'existe qu'un commit après
    // l'ouverture : le ref est encore nul ici, on re-mesure au tick suivant.
    const lateMount = setTimeout(compute, 0);
    window.addEventListener('resize', compute);
    window.addEventListener('scroll', compute, true);
    return () => {
      clearTimeout(lateMount);
      window.removeEventListener('resize', compute);
      window.removeEventListener('scroll', compute, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return flip;
}
